import { ThemeProvider, createTheme } from '@mui/material';
import {
  daDK,
  deDE,
  enUS,
  fiFI,
  frFR,
  nbNO,
  nlNL,
  ruRU,
  svSE,
} from '@mui/material/locale';
import {
  daDK as dataGridDaDK,
  deDE as dataGridDeDE,
  enUS as dataGridEnUS,
  fiFI as dataGridFiFI,
  frFR as dataGridFrFR,
  nbNO as dataGridNbNO,
  nlNL as dataGridNlNL,
  ruRU as dataGridRuRU,
  svSE as dataGridSvSE,
} from '@mui/x-data-grid-pro/locales';
import {
  daDK as pickersDaDK,
  deDE as pickersDeDE,
  enUS as pickersEnUS,
  fiFI as pickersFiFI,
  frFR as pickersFrFR,
  nbNO as pickersNbNO,
  nlNL as pickersNlNL,
  ruRU as pickersRuRU,
  svSE as pickersSvSE,
} from '@mui/x-date-pickers-pro/locales';
import { ConfirmProvider } from 'material-ui-confirm';
import { ReactNode, useMemo } from 'react';
// This is needed to add default props for the DataGrid in theme
import type {} from '@mui/x-data-grid-pro/themeAugmentation';
import { useGetCurrentLanguage } from '@legacy/apis/userSettingsAPI';
import { timeLogThemeOptions } from '@legacy/assets/themes/timelog.theme';

const localeMap = {
  da: [daDK, dataGridDaDK, pickersDaDK],
  de: [deDE, dataGridDeDE, pickersDeDE],
  en: [enUS, dataGridEnUS, pickersEnUS],
  fi: [fiFI, dataGridFiFI, pickersFiFI],
  nb: [nbNO, dataGridNbNO, pickersNbNO],
  nl: [nlNL, dataGridNlNL, pickersNlNL],
  ru: [ruRU, dataGridRuRU, pickersRuRU],
  sv: [svSE, dataGridSvSE, pickersSvSE],
  fr: [frFR, dataGridFrFR, pickersFrFR],
};

const useGetDateLocale = () => {
  const { currentLanguage, isSuccess } = useGetCurrentLanguage();

  if (isSuccess) {
    return currentLanguage ? localeMap[currentLanguage] : localeMap.en;
  }

  return localeMap.en;
};

export const MuiWrapper = ({ children }: { children: ReactNode }) => {
  const locale = useGetDateLocale();

  const timelogTheme = useMemo(
    () => createTheme(timeLogThemeOptions, ...locale),
    [locale],
  );
  return (
    <ThemeProvider theme={timelogTheme}>
      <ConfirmProvider>{children}</ConfirmProvider>
    </ThemeProvider>
  );
};
